import {
  copyToClipboard, DOM, isMobile, sendEmail,
} from 'new-ui/functions';
import './Iframe.css';

import xIcon from 'assets/icons/x.svg';
import { INTERCOM_EVENTS } from 'modules/intercom/intercom';
import EnvelopIcon from './assets/icons/envelop.svg';
import ShareIcon from './assets/icons/share.svg';

export class ArticleInIframe {
  show({ src, onClose }) {
    this.$iframe = DOM('.iframe-overlay', {
      '/.child.top': {
        '/.close': {
          '/img': {
            src: xIcon,
          },
          onclick: () => {
            this.hide.call(this);
            if (onClose) {
              onClose();
            }
          },
        },
      },
      '/.child.middle': {
        name: 'middle',
        '/iframe': {
          src,
        },
      },
      '/.child.bottom': {
        '/.share': {
          onclick: this.shareLink.bind(this, src),
          '/.share-icon.link': {
            '/img': {
              src: ShareIcon,
            },
          },
          '/.share-title': {
            innerHTML: 'Share',
          },
        },
        '/.share-icon.email': {
          onclick: this.shareEmail.bind(this, src),
          '/img': {
            src: EnvelopIcon,
          },
          '/.email-title': {
            innerHTML: 'Email this article',
          },
        },
      },
    });
    document.body.appendChild(this.$iframe);
  }

  hide() {
    if (!this.$iframe) {
      return;
    }

    document.body.removeChild(this.$iframe);
    this.$iframe = null;
  }

  async shareLink(src) {
    const url = src.split('?')[0];
    window.app.intercom.sendEvent(INTERCOM_EVENTS.SHARE.BLOGPOST, {
      blog: url,
      device: isMobile() ? 'mobile' : 'desktop',
      content: 'link',
    });
    if (navigator.share) {
      await navigator.share({
        title: 'Interesting article I found!',
        text: 'I just found an interesting article that might interest you',
        url,
      });
    } else {
      const copied = await copyToClipboard(url);
      if (copied) {
        window.app.alert({ content: 'Link copied successfully' });
      }
    }
  }

  shareEmail(src) {
    const url = src.split('?')[0];
    window.app.intercom.sendEvent(INTERCOM_EVENTS.SHARE.BLOGPOST, {
      blog: url,
      device: isMobile() ? 'mobile' : 'desktop',
      content: 'email',
    });
    sendEmail('', 'Interesting article I found!', `Hi,\n\rI just found an interesting article that might interest you:\n${url}&source=sharing_email\n\rBest Regards!`);
  }
}
